import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import UserService from '../../services/userService';
import BusinessUnitService from '../../services/businessUnitService';
import MapGroupScreenService from '../../services/mapGroupScreenService';
import { showLoading, hideLoading, showConfirm, showSuccess, showError } from '../../../src/components/utils/swal-helpers';
import { SetDataFullName, SetDataMenuData, SetDataUserGroup, SetDataUserID } from '../../components/utils/data-storage';

const Profile = () => {
    const navigate = useNavigate();
    const { email } = useParams();
    const [dataBU, setDataBU] = useState([]);
    const [selectBU, setSelectBU] = useState("");
    const [codeBackPage, setCodeBackPage] = useState("LGN");
    const [objUser, setObjUser] = useState({
        id_business_unit: "",
        id_user_group: 0,
        email: "",
        name: "",
        surname: "",
        department: "",
        tel: "",
        domain: ""
    });

    useEffect(() => {
        console.log("email param:", email);
        if (!email) {
            const mockEmail = "test@company.com";
            const mockDomain = "company.com";
            LoadDataBusinessUnit(mockDomain, mockEmail);
            LoadAndCheckDataUser(mockEmail);
            return;
        }

        let strEmail = "";
        try {
            const strParams = atob(email);
            const arrParams = strParams.split("::");
            strEmail = arrParams[0];
            setCodeBackPage(arrParams[1]);
        } catch (error) {
            strEmail = "";
        }

        if (strEmail === "") {
            // TODO: เปิดเมื่อ backend พร้อม
            navigate("/login", { replace: true });
            return;
        }

        const arrDomain = strEmail.split("@");
        const strDomain = (arrDomain.length > 1) ? arrDomain[1] : "-";
        LoadDataBusinessUnit(strDomain, strEmail);
        LoadAndCheckDataUser(strEmail);

    }, [email]);

    useEffect(() => {
        if (dataBU.length > 0) {
            setSelectBU(dataBU.find(x => x.value === objUser.id_business_unit.toString()) ?? "");
        }
    }, [dataBU, objUser]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: objUser.id || 0,
            id_business_unit: objUser.id_business_unit || "",
            id_user_group: objUser.id_user_group || 0,
            email: objUser.email || "",
            tel: objUser.tel || "",
            name: objUser.name || "",
            surname: objUser.surname || "",
            department: objUser.department || "",
            status: 1,
        },
        validationSchema: Yup.object({
            id_business_unit: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            email: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            tel: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            name: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            surname: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
            department: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
        }),
        onSubmit: (values) => {
            // console.log("values ที่จะส่ง:", JSON.stringify(values, null, 2));
            values.id_business_unit = (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : null;
            values.scope = "read_write";
            if (values.id > 0) {
                UpdateUser(values.id, values);
            } else {
                AddUser(values);
            }
        }
    });

    const OnClickBack = () => {
        const routes = {
            ADB: "/admin/dashboard",
            AAR: "/admin/requests",
            UDB: "/user/dashboard",
            UAR: "/user/requests",
            RRR: "/admin/report-requests",
            MAC: "/admin/company",
            MAM: "/admin/messenger",
        };
        navigate(routes[codeBackPage] || "/login", { replace: true });
    };

    const LoadAndCheckDataUser = async (email) => {
        try {
            const response = await UserService.SearchUser({ email, status: 1 });
            if (response.data.is_success === true && response.data.result?.length > 0) {
                setObjUser(response.data.result[0]);
            } else {
                setObjUser({
                    id_business_unit: "",
                    id_user_group: 1,
                    email,
                    name: "",
                    surname: "",
                    department: "",
                    tel: "",
                    domain: ""
                });
            }
        } catch (error) {
            console.error("LoadAndCheckDataUser error:", error);
            setObjUser({
                id_business_unit: "",
                id_user_group: 1,
                email,
                name: "",
                surname: "",
                department: "",
                tel: "",
                domain: ""
            });
        }
    };

    const LoadDataBusinessUnit = async (domain, strEmail) => {
        console.log("LoadDataBusinessUnit called:", domain, strEmail);
        try {
            const resp = await BusinessUnitService.SearchBusinessUnit({ domain, status: 1 });
            console.log("BusinessUnit response:", resp.data);
            if (resp.data.is_success === true && resp.data.result?.length > 0) {
                setDataBU(resp.data.result.map(e => ({
                    label: e.name_en,
                    value: e.id.toString()
                })));
            } else {
                // TODO: เปิดเมื่อ backend พร้อม
                navigate("/login", { replace: true });
            }
        } catch (error) {
            console.error("LoadDataBusinessUnit error:", error);
            // TODO: เปิดเมื่อ backend พร้อม
            navigate("/login", { replace: true });
        }
    };

    const AddUser = async (req) => {
        const confirm = await showConfirm({
            title: "ยืนยันการสร้างโปรไฟล์",
            detail: "กด Confirm เพื่อทำการสร้างโปรไฟล์ให้สำเร็จ"
        });
        if (!confirm.isConfirmed) return;
    
        try {
            showLoading();
            const respUser = await UserService.CreateUser(req);
            if (respUser.data.is_success === true && respUser.data.result !== null) {
                SetDataUserID(respUser.data.result.id);
                SetDataFullName(respUser.data.result.name + " " + respUser.data.result.surname);
                SetDataUserGroup(respUser.data.result.id_user_group);
                const respScreen = await MapGroupScreenService.GetMapGroupScreens({
                    id_user_group: respUser.data.result.id_user_group,
                    status: 1
                });
                hideLoading();
                SetDataMenuData(respScreen.data.result || []);
                await showSuccess({
                    title: "สร้างโปรไฟล์สำเร็จ",
                    detail: "สามารถเข้าใช้งานระบบ Mercury ได้ด้วย Email"
                });
                navigate("/user/requests", { replace: true });
            } else {
                hideLoading();
                showError();
            }
        } catch (error) {
            hideLoading();
            showError();
            console.error("AddUser error:", error);
        }
    };

    const UpdateUser = async (id, req) => {
        const confirm = await showConfirm({
            title: "ยืนยันการแก้ไขโปรไฟล์",
            detail: "กด Confirm เพื่อทำการแก้ไขโปรไฟล์ให้สำเร็จ"
        });
        if (!confirm.isConfirmed) return;
    
        try {
            const resp = await UserService.UpdateUser(id, req);
            if (resp.data.is_success === true) {
                SetDataFullName(req.name + " " + req.surname);
                await showSuccess({
                    title: "แก้ไขโปรไฟล์สำเร็จ",
                    detail: "สามารถเข้าใช้งานระบบ Mercury ได้ด้วย Email"
                });
                OnClickBack();
            } else {
                showError();
            }
        } catch (error) {
            showError();
            console.error("UpdateUser error:", error);
        }
    };

    const isCreate = codeBackPage === "LGN";

    return (
        <div className="profile-page">
            <div style={{ maxWidth: 900, margin: "0 auto" }}>

                {/* ── Page Header ── */}
                <div className="profile-page-header">
                    <h1 className="profile-page-header__title">
                        {isCreate ? "สร้างโปรไฟล์ Create profile" : "แก้ไขโปรไฟล์ Update profile"}
                    </h1>
                    <p className="profile-page-header__subtitle">
                        ใส่ข้อมูลของคุณเพื่อใช้งานระบบ Mercury
                    </p>
                </div>

                {/* ── Card ── */}
                <div className="profile-card">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                        noValidate
                    >
                        {/* Username */}
                        <div className="profile-form-row profile-form-row--1col">
                            <div>
                                <label className="profile-label" htmlFor="txtEmail">
                                    ชื่อผู้ใช้ (Username)
                                </label>
                                <input
                                    id="txtEmail"
                                    name="email"
                                    type="text"
                                    className="profile-input"
                                    disabled
                                    value={validation.values.email || ""}
                                    onChange={validation.handleChange}
                                />
                            </div>
                        </div>

                        {/* Name / Surname */}
                        <div className="profile-form-row profile-form-row--2col">
                            <div>
                                <label className="profile-label" htmlFor="txtName">
                                    ชื่อ (Name)<span className="required-mark">*</span>
                                </label>
                                <input
                                    id="txtName"
                                    name="name"
                                    type="text"
                                    placeholder="ชื่อ (Name)"
                                    className={`profile-input${validation.touched.name && validation.errors.name ? " is-invalid" : ""}`}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.name || ""}
                                />
                                {validation.touched.name && validation.errors.name &&
                                    <div className="profile-invalid-feedback">{validation.errors.name}</div>
                                }
                            </div>
                            <div>
                                <label className="profile-label" htmlFor="txtSurname">
                                    สกุล (Surname)<span className="required-mark">*</span>
                                </label>
                                <input
                                    id="txtSurname"
                                    name="surname"
                                    type="text"
                                    placeholder="สกุล (Surname)"
                                    className={`profile-input${validation.touched.surname && validation.errors.surname ? " is-invalid" : ""}`}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.surname || ""}
                                />
                                {validation.touched.surname && validation.errors.surname &&
                                    <div className="profile-invalid-feedback">{validation.errors.surname}</div>
                                }
                            </div>
                        </div>

                        {/* Company / Department */}
                        <div className="profile-form-row profile-form-row--2col">
                            <div>
                                <label className="profile-label" htmlFor="ddlBusinessUnit">
                                    บริษัท (Company)<span className="required-mark">*</span>
                                </label>
                                <Select
                                    inputId="ddlBusinessUnit"
                                    name="id_business_unit"
                                    classNamePrefix="select"
                                    className={`profile-select${validation.touched.id_business_unit && validation.errors.id_business_unit ? " is-invalid" : ""}`}
                                    value={selectBU}
                                    onChange={(selected) => {
                                        setSelectBU(selected);
                                        validation.handleChange('id_business_unit')((selected !== null) ? selected.value : "");
                                    }}
                                    options={dataBU}
                                    isClearable
                                    isSearchable
                                    placeholder="Select"
                                />
                                {validation.touched.id_business_unit && validation.errors.id_business_unit &&
                                    <div className="profile-invalid-feedback">{validation.errors.id_business_unit}</div>
                                }
                            </div>
                            <div>
                                <label className="profile-label" htmlFor="txtDepartment">
                                    แผนก (Department)<span className="required-mark">*</span>
                                </label>
                                <input
                                    id="txtDepartment"
                                    name="department"
                                    type="text"
                                    placeholder="แผนก (Department)"
                                    className={`profile-input${validation.touched.department && validation.errors.department ? " is-invalid" : ""}`}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.department || ""}
                                />
                                {validation.touched.department && validation.errors.department &&
                                    <div className="profile-invalid-feedback">{validation.errors.department}</div>
                                }
                            </div>
                        </div>

                        {/* Contact Number */}
                        <div className="profile-form-row profile-form-row--1col">
                            <div>
                                <label className="profile-label" htmlFor="txtTel">
                                    เบอร์โทรศัพท์ที่ติดต่อได้ (Contact number)<span className="required-mark">*</span>
                                </label>
                                <input
                                    id="txtTel"
                                    name="tel"
                                    type="text"
                                    placeholder="เบอร์โทรศัพท์ที่ติดต่อได้ (Contact number)"
                                    className={`profile-input${validation.touched.tel && validation.errors.tel ? " is-invalid" : ""}`}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.tel || ""}
                                />
                                {validation.touched.tel && validation.errors.tel &&
                                    <div className="profile-invalid-feedback">{validation.errors.tel}</div>
                                }
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="profile-actions">
                            <button
                                type="button"
                                className="btn-profile-back"
                                onClick={OnClickBack}
                            >
                                Back
                            </button>
                            <button
                                type="submit"
                                className="btn-profile-submit"
                            >
                                {isCreate ? "Register" : "Save"}
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
};

export default Profile;